const state = {
  package_list: ['iuu']
}

const actions = {

}

export default {
  namespaced: true,
  state,
  // mutations,
  actions
}
